const LINK_TYPES = {
  CONTACT_SALES: 'CONTACT_SALES',
  CONTACT_SUPPORT: 'CONTACT_SUPPORT',
  COMPARE: 'COMPARE',
  REGISTER_TO_NEWSLETTER: 'REGISTER_TO_NEWSLETTER',
  REGISTER_PRODUCT: 'REGISTER_PRODUCT',
  ADD_TO_MY_PRODUCTS: 'ADD_TO_MY_PRODUCTS',
  CHECK_DISTRIBUTOR: 'CHECK_DISTRIBUTOR',
};
const ICONS_BY_TYPE = {
  [LINK_TYPES.CONTACT_SALES]: 'action_test',
  [LINK_TYPES.CONTACT_SUPPORT]: 'communication_bubbles2',
  [LINK_TYPES.REGISTER_TO_NEWSLETTER]: 'mail',
  [LINK_TYPES.REGISTER_PRODUCT]: 'page',
  [LINK_TYPES.CHECK_DISTRIBUTOR]: 'action_test',
};
const TARGET_BY_TYPE = {
  [LINK_TYPES.CONTACT_SALES]: '_self',
  [LINK_TYPES.CONTACT_SUPPORT]: '_blank',
  [LINK_TYPES.REGISTER_PRODUCT]: '_blank',
  [LINK_TYPES.CHECK_DISTRIBUTOR]: '_self',
};

export { ICONS_BY_TYPE as I, LINK_TYPES as L, TARGET_BY_TYPE as T };
